import React from 'react';
import packageJson from '../../../package.json';

const VersionDisplay = ({ className = '', style = {} }) => {
  return (
    <div 
      className={`version-display ${className}`}
      style={{
        fontSize: '12px',
        color: '#666',
        opacity: 0.7,
        userSelect: 'none',
        ...style
      }}
    >
      v{packageJson.version}
    </div>
  );
};

export default VersionDisplay;